"use strict";

var _regeneratorRuntime = require("/codebuild/output/src2552594638/src/corporate_sites/node_modules/@babel/runtime/regenerator/index.js");
function asyncGeneratorStep(e, n, i, t, r, a, o) {
  try {
    var s = e[a](o),
      p = s.value;
  } catch (e) {
    return void i(e);
  }
  s.done ? n(p) : Promise.resolve(p).then(t, r);
}
function _asyncToGenerator(e) {
  return function () {
    var n = this,
      i = arguments;
    return new Promise(function (t, r) {
      var a = e.apply(n, i);
      function o(e) {
        asyncGeneratorStep(a, t, r, o, s, "next", e);
      }
      function s(e) {
        asyncGeneratorStep(a, t, r, o, s, "throw", e);
      }
      o(void 0);
    });
  };
}
function _classCallCheck(e, n) {
  if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, n) {
  for (var i = 0; i < n.length; i++) {
    var t = n[i];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
  }
}
function _createClass(e, n, i) {
  return n && _defineProperties(e.prototype, n), i && _defineProperties(e, i), e;
}
var mapper = require("./../helper/mapper"),
  BackendService = require("./../Backend.service");
mapper = new mapper.Mapper();
var axios = require("axios"),
  unflatten = require("flat").unflatten,
  Paclife = function () {
    return _createClass(function e(n) {
      _classCallCheck(this, e), this.envObject = n;
    }, [{
      key: "getQuestions",
      value: (n = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var n;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = [{
                question_sequence: 1,
                component_id: "policyOwner",
                question_text: "Will the person whose life is insured on the policy be different than the owner of the policy?",
                question_sub_text: "",
                question_format: "text",
                image_url: "https://some-image-url.com/image.png",
                answer_type: "radio",
                radio_options: [{
                  answer_text: "Yes",
                  image_url: "https://some-image-url.com/image.png",
                  on_select: {
                    action: "show"
                  },
                  answer_key: "ownerInsuredDifferent"
                }, {
                  answer_text: "No",
                  image_url: "https://some-image-url.com/image.png",
                  on_select: {
                    action: "hide"
                  },
                  answer_key: "ownerInsuredDifferent"
                }],
                sub_questions: {
                  count: 3,
                  question_1: {
                    question_text: "Policy Owner Information",
                    question_sub_text: "",
                    question_format: "collapsable_card",
                    image_url: "",
                    answer_type: "group_of_inputs",
                    group_key: "policyOwnerInfo",
                    group_of_inputs: {
                      count: 10,
                      answer_1: {
                        answer_type: "dropdown",
                        dropdown_options: ["Boyfriend", "Child", "Child-in-Law", "Domestic Partner", "Fiancee", "Former Spouse", "Friend", "Girlfriend", "Grand Parent", "Grandchildren", "Legal Guardian for children", "Life Partner", "Nephew", "Niece", "Other", "Other Relative", "Parent", "Parents-in-Law", "Self", "Sibling", "Sibling-in-Law", "Spouse", "Step-child", "Step-parent"],
                        placeholder: "Choose Relationship",
                        answer_key: "policyOwnerRelationship"
                      },
                      answer_2: {
                        answer_type: "input",
                        input_validation: "all",
                        placeholder: "First Name",
                        answer_key: "policyOwnerFirstName"
                      },
                      answer_3: {
                        answer_type: "input",
                        input_validation: "all",
                        placeholder: "Last Name",
                        answer_key: "policyOwnerLastName"
                      },
                      answer_4: {
                        answer_type: "dob",
                        input_validation: "",
                        placeholder: "Date of birth",
                        answer_key: "policyOwnerDob"
                      },
                      answer_5: {
                        answer_type: "input",
                        input_validation: "number",
                        placeholder: "Social Security Number",
                        answer_key: "policyOwnerSSN"
                      },
                      answer_6: {
                        answer_type: "input",
                        input_validation: "email",
                        placeholder: "Email ID",
                        answer_key: "policyOwnerEmail"
                      },
                      answer_7: {
                        answer_type: "input",
                        input_validation: "all",
                        placeholder: "Current Street Address",
                        answer_key: "policyOwnerStreetAddress"
                      },
                      answer_8: {
                        answer_type: "input",
                        input_validation: "all",
                        placeholder: "City",
                        answer_key: "policyOwnerCity"
                      },
                      answer_9: {
                        answer_type: "dropdown",
                        dropdown_options: ["AA", "AE", "AK", "AL", "AP", "AR", "AS", "AZ", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "GB", "GU", "HI", "IA", "ID", "IL", "IN", "KS", "KY", "LA", "MA", "MD", "ME", "MI", "MN", "MO", "MP", "MS", "MT", "NC", "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "OH", "OK", "OR", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VA", "VI", "VT", "WA", "WI", "WV", "WY"],
                        placeholder: "Choose",
                        answer_key: "policyOwnerState"
                      },
                      answer_10: {
                        answer_type: "input",
                        input_validation: "all",
                        placeholder: "ZIP Code",
                        answer_key: "policyOwnerZipcode"
                      }
                    }
                  },
                  question_2: {
                    question_text: "Insured's Information",
                    question_sub_text: "",
                    question_format: "collapsable_card",
                    image_url: "",
                    answer_type: "group_of_inputs",
                    group_key: "insuredInfo",
                    group_of_inputs: {
                      count: 4,
                      answer_1: {
                        answer_type: "input",
                        input_validation: "all",
                        placeholder: "Current Street Address",
                        answer_key: "insuredStreetAddress"
                      },
                      answer_2: {
                        answer_type: "input",
                        input_validation: "all",
                        placeholder: "City",
                        answer_key: "insuredCity"
                      },
                      answer_3: {
                        answer_type: "dropdown",
                        dropdown_options: ["AA", "AE", "AK", "AL", "AP", "AR", "AS", "AZ", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "GB", "GU", "HI", "IA", "ID", "IL", "IN", "KS", "KY", "LA", "MA", "MD", "ME", "MI", "MN", "MO", "MP", "MS", "MT", "NC", "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "OH", "OK", "OR", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VA", "VI", "VT", "WA", "WI", "WV", "WY"],
                        placeholder: "Choose",
                        answer_key: "insuredState"
                      },
                      answer_4: {
                        answer_type: "input",
                        input_validation: "all",
                        placeholder: "ZIP Code",
                        answer_key: "insuredZipcode"
                      }
                    }
                  },
                  question_3: {
                    question_text: "",
                    question_sub_text: "Has the insured's legal name changed in the last 5 years?",
                    question_format: "collapsable_card",
                    image_url: "",
                    answer_type: "radio",
                    radio_options: [{
                      answer_text: "Yes",
                      image_url: "https://some-image-url.com/image.png",
                      on_select: {
                        action: "show"
                      },
                      answer_key: "insuredLegalNameChanged"
                    }, {
                      answer_text: "No",
                      image_url: "https://some-image-url.com/image.png",
                      on_select: {
                        action: "hide"
                      },
                      answer_key: "insuredLegalNameChanged"
                    }],
                    sub_questions: {
                      count: 1,
                      question_1: {
                        question_text: "",
                        question_sub_text: "",
                        question_format: "",
                        image_url: "",
                        answer_type: "group_of_inputs",
                        group_key: "insuredFormerInfo",
                        group_of_inputs: {
                          count: 2,
                          answer_1: {
                            answer_type: "input",
                            input_validation: "all",
                            placeholder: "Former first Name",
                            answer_key: "formerFirstName"
                          },
                          answer_2: {
                            answer_type: "input",
                            input_validation: "all",
                            placeholder: "Former last Name",
                            answer_key: "formerlastName"
                          }
                        }
                      }
                    }
                  }
                },
                on_submit: "proceed"
              }, {
                question_sequence: 2,
                component_id: "isActiveMilitary",
                question_text: "Is the insured currently serving in the military?",
                question_sub_text: "",
                question_format: "text",
                image_url: "https://some-image-url.com/image.png",
                answer_type: "radio",
                radio_options: [{
                  answer_text: "Yes",
                  image_url: "https://some-image-url.com/image.png",
                  on_select: {
                    action: "proceed"
                  },
                  answer_key: "isActiveMilitary"
                }, {
                  answer_text: "No",
                  image_url: "https://some-image-url.com/image.png",
                  on_select: {
                    action: "proceed"
                  },
                  answer_key: "isActiveMilitary"
                }],
                on_submit: "proceed"
              }, {
                question_sequence: 3,
                component_id: "countryBorn",
                question_text: "In which state and country was the insured born?",
                question_sub_text: "",
                question_format: "text",
                image_url: "https://some-image-url.com/image.png",
                answer_type: "dropdown",
                dropdown_options: ["US", "IN"],
                placeholder: "Choose",
                answer_key: "countryBorn",
                sub_questions: {
                  count: 1,
                  question_1: {
                    question_text: "In which state and country was the insured born?",
                    question_sub_text: "",
                    question_format: "",
                    image_url: "",
                    answer_type: "dropdown",
                    dropdown_options: ["AA", "AE", "AK", "AL", "AP", "AR", "AS", "AZ", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "GB", "GU", "HI", "IA", "ID", "IL", "IN", "KS", "KY", "LA", "MA", "MD", "ME", "MI", "MN", "MO", "MP", "MS", "MT", "NC", "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "OH", "OK", "OR", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VA", "VI", "VT", "WA", "WI", "WV", "WY"],
                    placeholder: "Choose",
                    answer_key: "stateBorn"
                  }
                },
                on_submit: "proceed"
              }, {
                question_sequence: 4,
                component_id: "isInsuredDependent",
                question_text: "Does the insured depend on anyone else for financial support?",
                question_sub_text: "",
                question_format: "text",
                image_url: "https://some-image-url.com/image.png",
                answer_type: "radio",
                radio_options: [{
                  answer_text: "Yes",
                  image_url: "https://some-image-url.com/image.png",
                  on_select: {
                    action: "proceed"
                  },
                  answer_key: "isInsuredDependent"
                }, {
                  answer_text: "No",
                  image_url: "https://some-image-url.com/image.png",
                  on_select: {
                    action: "proceed"
                  },
                  answer_key: "isInsuredDependent"
                }],
                on_submit: "proceed"
              }, {
                question_sequence: 5,
                component_id: "thirdPartyNotified",
                question_text: "Is a third party individual to be notified if coverage is about to lapse or has lapsed?",
                question_sub_text: "",
                question_format: "text",
                image_url: "https://some-image-url.com/image.png",
                answer_type: "radio",
                radio_options: [{
                  answer_text: "Yes",
                  image_url: "https://some-image-url.com/image.png",
                  on_select: {
                    action: "show"
                  },
                  answer_key: "thirdPartyNotified"
                }, {
                  answer_text: "No",
                  image_url: "https://some-image-url.com/image.png",
                  on_select: {
                    action: "hide"
                  },
                  answer_key: "thirdPartyNotified"
                }],
                sub_questions: {
                  count: 1,
                  question_1: {
                    question_text: "Third party addressee information",
                    question_sub_text: "",
                    question_format: "text",
                    image_url: "",
                    answer_type: "group_of_inputs",
                    group_key: "thirdPartyInfo",
                    group_of_inputs: {
                      count: 7,
                      answer_1: {
                        answer_type: "input",
                        input_validation: "all",
                        placeholder: "First Name",
                        answer_key: "thirdPartyFirstName"
                      },
                      answer_2: {
                        answer_type: "input",
                        input_validation: "all",
                        placeholder: "Last Name",
                        answer_key: "thirdPartyLastName"
                      },
                      answer_3: {
                        answer_type: "input",
                        input_validation: "phone",
                        placeholder: "Phone Number",
                        answer_key: "thirdPartyPhone"
                      },
                      answer_4: {
                        answer_type: "input",
                        input_validation: "all",
                        placeholder: "Street Address",
                        answer_key: "thirdPartyStreetAddress"
                      },
                      answer_5: {
                        answer_type: "input",
                        input_validation: "all",
                        placeholder: "City",
                        answer_key: "thirdPartyCity"
                      },
                      answer_6: {
                        answer_type: "dropdown",
                        dropdown_options: ["AA", "AE", "AK", "AL", "AP", "AR", "AS", "AZ", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "GB", "GU", "HI", "IA", "ID", "IL", "IN", "KS", "KY", "LA", "MA", "MD", "ME", "MI", "MN", "MO", "MP", "MS", "MT", "NC", "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "OH", "OK", "OR", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VA", "VI", "VT", "WA", "WI", "WV", "WY"],
                        placeholder: "State",
                        answer_key: "thirdPartyState"
                      },
                      answer_7: {
                        answer_type: "input",
                        input_validation: "all",
                        placeholder: "ZIP Code",
                        answer_key: "thirdPartyZipcode"
                      }
                    }
                  }
                },
                on_submit: "proceed"
              }, {
                question_sequence: 6,
                component_id: "addBeneficiaries",
                question_text: "Beneficiary information",
                question_sub_text: "Add primary beneficiaries below. Ultimately, there must be a minimum of one, and up to a maximum of four primary beneficiaries. The total of all primary beneficiary shares must equal 100%",
                question_format: "text",
                image_url: "https://some-image-url.com/image.png",
                answer_type: "group_of_inputs",
                group_key: "addBeneficiaryInfo",
                group_of_inputs: {
                  count: 5,
                  answer_1: {
                    answer_type: "input",
                    input_validation: "all",
                    placeholder: "First Name",
                    answer_key: "addBeneficiaryFirstName"
                  },
                  answer_2: {
                    answer_type: "input",
                    input_validation: "all",
                    placeholder: "Last Name",
                    answer_key: "addBeneficiaryLastName"
                  },
                  answer_3: {
                    answer_type: "dropdown",
                    dropdown_options: ["Boyfriend", "Business", "Business Associate", "Business Partner", "Charity", "Child", "Child-in-Law", "Domestic Partner", "Employer", "Estate", "Fiancee", "Former Spouse", "Friend", "Girlfriend", "Grand Parent", "Grandchildren", "Legal Guardian for children", "Life Partner", "Nephew", "Niece", "Other", "Other Relative", "Parent", "Parents-in-Law", "Self", "Sibling", "Sibling-in-Law", "Spouse", "Step-child", "Step-parent", "Trust"],
                    placeholder: "Choose Relationship",
                    answer_key: "addBeneficiaryRelationship"
                  },
                  answer_4: {
                    answer_type: "dob",
                    input_validation: "",
                    placeholder: "Date of birth",
                    answer_key: "addBeneficiaryDob"
                  },
                  answer_5: {
                    answer_type: "input",
                    input_validation: "number",
                    placeholder: "--",
                    answer_key: "addBeneficiaryPercentage"
                  },
                  answer_6: {
                    answer_type: "checkbox",
                    answer_text: "I confirm this beneficiary will be finically impacted by your death",
                    input_validation: "",
                    placeholder: "",
                    answer_key: "addBeneficiaryConfirm"
                  }
                },
                on_submit: "proceed"
              }, {
                question_sequence: 7,
                component_id: "contingentBeneficiaries",
                question_text: "Do you want to add a contingent beneficiary?",
                question_sub_text: "",
                question_format: "text",
                image_url: "https://some-image-url.com/image.png",
                answer_type: "radio",
                radio_options: [{
                  answer_text: "Yes",
                  image_url: "https://some-image-url.com/image.png",
                  on_select: {
                    action: "proceed"
                  },
                  answer_key: "contingentBeneficiaries"
                }, {
                  answer_text: "No",
                  image_url: "https://some-image-url.com/image.png",
                  on_select: {
                    action: "proceed"
                  },
                  answer_key: "contingentBeneficiaries"
                }],
                sub_questions: {
                  count: 1,
                  question_1: {
                    question_text: "",
                    question_sub_text: "",
                    question_format: "",
                    image_url: "",
                    answer_type: "group_of_inputs",
                    group_key: "contingentBeneficiaryInfo",
                    group_of_inputs: {
                      count: 5,
                      answer_1: {
                        answer_type: "input",
                        input_validation: "all",
                        placeholder: "First Name",
                        answer_key: "contingentBeneficiaryFirstName"
                      },
                      answer_2: {
                        answer_type: "input",
                        input_validation: "all",
                        placeholder: "Last Name",
                        answer_key: "contingentBeneficiaryLastName"
                      },
                      answer_3: {
                        answer_type: "dropdown",
                        dropdown_options: ["Boyfriend", "Business", "Business Associate", "Business Partner", "Charity", "Child", "Child-in-Law", "Domestic Partner", "Employer", "Estate", "Fiancee", "Former Spouse", "Friend", "Girlfriend", "Grand Parent", "Grandchildren", "Legal Guardian for children", "Life Partner", "Nephew", "Niece", "Other", "Other Relative", "Parent", "Parents-in-Law", "Self", "Sibling", "Sibling-in-Law", "Spouse", "Step-child", "Step-parent", "Trust"],
                        placeholder: "Choose Relationship",
                        answer_key: "contingentBeneficiaryRelationship"
                      },
                      answer_4: {
                        answer_type: "dob",
                        input_validation: "",
                        placeholder: "Date of birth",
                        answer_key: "contingentBeneficiaryDob"
                      },
                      answer_5: {
                        answer_type: "input",
                        input_validation: "number",
                        placeholder: "--",
                        answer_key: "contingentBeneficiaryPercentage"
                      },
                      answer_6: {
                        answer_type: "checkbox",
                        answer_text: "I confirm this beneficiary will be finically impacted by your death",
                        input_validation: "",
                        placeholder: "",
                        answer_key: "contingentBeneficiaryConfirm"
                      }
                    }
                  }
                },
                on_submit: "proceed"
              }, {
                question_sequence: 8,
                component_id: "hasDriverLicense",
                question_text: "Does the insured have a driver's license?",
                question_sub_text: "",
                question_format: "text",
                image_url: "https://some-image-url.com/image.png",
                answer_type: "radio",
                radio_options: [{
                  answer_text: "Yes",
                  image_url: "https://some-image-url.com/image.png",
                  on_select: {
                    action: "show"
                  },
                  answer_key: "hasDriverLicense"
                }, {
                  answer_text: "No",
                  image_url: "https://some-image-url.com/image.png",
                  on_select: {
                    action: "hide"
                  },
                  answer_key: "hasDriverLicense"
                }],
                sub_questions: {
                  count: 1,
                  question_1: {
                    question_text: "",
                    question_sub_text: "",
                    question_format: "",
                    image_url: "",
                    answer_type: "group_of_inputs",
                    group_key: "driverLicenseInfo",
                    group_of_inputs: {
                      count: 2,
                      answer_1: {
                        answer_type: "input",
                        input_validation: "number",
                        placeholder: "Driver's License Number",
                        answer_key: "driverLicenseNumber"
                      },
                      answer_2: {
                        answer_type: "dropdown",
                        dropdown_options: ["AA", "AE", "AK", "AL", "AP", "AR", "AS", "AZ", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "GB", "GU", "HI", "IA", "ID", "IL", "IN", "KS", "KY", "LA", "MA", "MD", "ME", "MI", "MN", "MO", "MP", "MS", "MT", "NC", "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "OH", "OK", "OR", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VA", "VI", "VT", "WA", "WI", "WV", "WY"],
                        placeholder: "State Issued",
                        answer_key: "driverLicenseIssuedState"
                      }
                    }
                  }
                },
                on_submit: "proceed"
              }, {
                question_sequence: 9,
                component_id: "hasPendingApplications",
                question_text: "Any pending applications or plans to apply for a life or annuity on the insured?",
                question_sub_text: "",
                question_format: "text",
                image_url: "https://some-image-url.com/image.png",
                answer_type: "radio",
                radio_options: [{
                  answer_text: "Yes",
                  image_url: "https://some-image-url.com/image.png",
                  on_select: {
                    action: "show"
                  },
                  answer_key: "hasPendingApplications"
                }, {
                  answer_text: "No",
                  image_url: "https://some-image-url.com/image.png",
                  on_select: {
                    action: "hide"
                  },
                  answer_key: "hasPendingApplications"
                }],
                sub_questions: {
                  count: 1,
                  question_1: {
                    question_text: "Pending Application",
                    question_sub_text: "",
                    question_format: "",
                    image_url: "",
                    answer_type: "group_of_inputs",
                    group_key: "pendingApplicationInfo",
                    group_of_inputs: {
                      count: 6,
                      answer_1: {
                        answer_type: "input",
                        input_validation: "all",
                        placeholder: "Company",
                        answer_key: "pendingApplicationCompany"
                      },
                      answer_2: {
                        answer_type: "input",
                        input_validation: "number",
                        placeholder: "Face Amount",
                        answer_key: "pendingApplicationFaceAmount"
                      },
                      answer_3: {
                        answer_type: "dropdown",
                        dropdown_options: ["Life", "Annuity"],
                        placeholder: "Product Type",
                        answer_key: "pendingApplicationProductType"
                      },
                      answer_4: {
                        answer_type: "dropdown",
                        dropdown_options: ["Group", "Individual"],
                        placeholder: "Type",
                        answer_key: "pendingApplicationType"
                      },
                      answer_5: {
                        answer_type: "dropdown",
                        dropdown_options: ["Personal", "Business"],
                        placeholder: "Purpose",
                        answer_key: "pendingApplicationPurpose"
                      },
                      answer_6: {
                        answer_type: "checkbox",
                        answer_text: "This policy will be purchased in addition to a Pacific Life policy",
                        input_validation: "",
                        placeholder: "",
                        answer_key: "pendingApplicationConfirm"
                      }
                    }
                  }
                },
                on_submit: "proceed"
              }, {
                question_sequence: 10,
                component_id: "hasExistingLifeInsurance",
                question_text: "Does the insured have an existing life insurance or annuity(ies)?",
                question_sub_text: "",
                question_format: "text",
                image_url: "https://some-image-url.com/image.png",
                answer_type: "radio",
                radio_options: [{
                  answer_text: "Yes",
                  image_url: "https://some-image-url.com/image.png",
                  on_select: {
                    action: "show"
                  },
                  answer_key: "hasExistingLifeInsurance"
                }, {
                  answer_text: "No",
                  image_url: "https://some-image-url.com/image.png",
                  on_select: {
                    action: "hide"
                  },
                  answer_key: "hasExistingLifeInsurance"
                }],
                sub_questions: {
                  count: 2,
                  question_1: {
                    question_text: "Is the policy owner considering discontinuing making premium payments, surrendering, forefeiting, assigning to the insurer, or otherwise terminating existing policies or contracts on the insured?",
                    question_sub_text: "",
                    question_format: "",
                    image_url: "",
                    answer_type: "radio",
                    radio_options: [{
                      answer_text: "Yes",
                      image_url: "https://some-image-url.com/image.png",
                      on_select: {
                        action: ""
                      },
                      answer_key: "terminatingExistingPolicies"
                    }, {
                      answer_text: "No",
                      image_url: "https://some-image-url.com/image.png",
                      on_select: {
                        action: ""
                      },
                      answer_key: "terminatingExistingPolicies"
                    }]
                  },
                  question_2: {
                    question_text: "Is the policy owner considering using funds from existing policies or contracts on the insured to pay premiums on the new policy or contract?",
                    question_sub_text: "",
                    question_format: "",
                    image_url: "",
                    answer_type: "radio",
                    radio_options: [{
                      answer_text: "Yes",
                      image_url: "https://some-image-url.com/image.png",
                      on_select: {
                        action: "show"
                      },
                      answer_key: "useFundsFromExistingPolicies"
                    }, {
                      answer_text: "No",
                      image_url: "https://some-image-url.com/image.png",
                      on_select: {
                        action: "hide"
                      },
                      answer_key: "useFundsFromExistingPolicies"
                    }],
                    sub_questions: {
                      count: 1,
                      question_1: {
                        question_text: "Existing Policy",
                        question_sub_text: "",
                        question_format: "",
                        image_url: "",
                        answer_type: "group_of_inputs",
                        group_key: "existingPolicyInfo",
                        group_of_inputs: {
                          count: 6,
                          answer_1: {
                            answer_type: "input",
                            input_validation: "all",
                            placeholder: "Company",
                            answer_key: "existingPolicyCompany"
                          },
                          answer_2: {
                            answer_type: "input",
                            input_validation: "number",
                            placeholder: "Policy Number (optional)",
                            answer_key: "existingPolicyNumber"
                          },
                          answer_3: {
                            answer_type: "input",
                            input_validation: "number",
                            placeholder: "Benefit amount",
                            answer_key: "existingPolicyBenefitAmount"
                          },
                          answer_4: {
                            answer_type: "dropdown",
                            dropdown_options: ["Life", "Annuity"],
                            placeholder: "Product Type",
                            answer_key: "existingPolicyProductType"
                          },
                          answer_5: {
                            answer_type: "dropdown",
                            dropdown_options: ["Group", "Individual"],
                            placeholder: "Type",
                            answer_key: "existingPolicyType"
                          },
                          answer_6: {
                            answer_type: "dropdown",
                            dropdown_options: ["Personal", "Business"],
                            placeholder: "Purpose",
                            answer_key: "existingPolicynPurpose"
                          },
                          answer_7: {
                            answer_type: "input",
                            dropdown_options: "number",
                            placeholder: "Issue year (optional)",
                            answer_key: "existingPolicyIssueYear"
                          },
                          answer_8: {
                            answer_type: "checkbox",
                            answer_text: "By applying for this life insurance policy, insured intends to replace, withdraw money from, take a loan from, allow policy to lapse, or otherwise change this existing life insurance policy or annuity",
                            input_validation: "",
                            placeholder: "",
                            answer_key: "existingPolicyConfirm"
                          }
                        }
                      }
                    }
                  }
                },
                on_submit: "proceed"
              }, {
                question_sequence: 11,
                component_id: "insurancePurpose",
                question_text: "What is your main insurance need?",
                question_sub_text: "",
                question_format: "text",
                image_url: "https://some-image-url.com/image.png",
                answer_type: "radio",
                radio_options: [{
                  answer_text: "Income Replacement",
                  image_url: "https://some-image-url.com/image.png",
                  on_select: {
                    action: ""
                  },
                  answer_key: "insurancePurpose"
                }, {
                  answer_text: "Estate Planning",
                  image_url: "https://some-image-url.com/image.png",
                  on_select: {
                    action: ""
                  },
                  answer_key: "insurancePurpose"
                }, {
                  answer_text: "Other - Personal",
                  image_url: "https://some-image-url.com/image.png",
                  on_select: {
                    action: ""
                  },
                  answer_key: "insurancePurpose"
                }],
                on_submit: "proceed"
              }, {
                question_sequence: 12,
                component_id: "ssn",
                question_text: "Please provide insured's Social Security Number",
                question_sub_text: "",
                question_format: "text",
                answer_type: "input",
                input_validation: "all",
                placeholder: "Enter Social Security Number",
                answer_key: "ssn",
                on_submit: "proceed"
              }], e.abrupt("return", n);
            case 3:
            case "end":
              return e.stop();
          }
        }, e);
      })), function () {
        return n.apply(this, arguments);
      })
    }, {
      key: "processTicket",
      value: (e = _asyncToGenerator(_regeneratorRuntime.mark(function e(n) {
        var i, t, r, a, o, s, p, c, u, l, d, _, m, y, g, w, f, h, I, P, A, x, N;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return i = BackendService.getPaclifeURL(this.envObject), t = (t = n.split("-"))[0], e.next = 5, BackendService.getAppData(t);
            case 5:
              for (r = e.sent, r = (r = JSON.parse(r.Payload)).body, console.log("clientData 2", r), console.log("clientData paclife_g8ul2b", r.paclife_g8ul2b), (a = unflatten(r.paclifeQuote)).success = !0, a.issueAge = Number(a.issueAge), a.faceAmount = Number(a.faceAmount), a.totRequestedFaceAmnt = Number(a.totRequestedFaceAmnt), a.premiumAmount = Number(a.premiumAmount), a.totRequestedFaceAmntPremium = Number(a.totRequestedFaceAmntPremium), a.smoker = "Yes" == a.smoker, o = 0; o < a.costIndices.length; o++) a.costIndices[o].year = Number(a.costIndices[o].year), a.costIndices[o].value = Number(a.costIndices[o].value);
              for (s = 0; s < r.addBeneficiaryInfo.length; s++) r.addBeneficiaryInfo[s].percentage = Number(r.addBeneficiaryInfo[s].percentage), r.addBeneficiaryInfo[s].classification = "Individual";
              if (p = "No" != r.isActiveMilitary, r.ssn = r.ssn.split("-").join(""), r.comfirmDetailsPhoneNumber = r.comfirmDetailsPhoneNumber.split("-").join(""), c = {
                quote: a,
                classification: "Individual",
                application_id: "BBL129-34321243",
                client_id: "client_id",
                existingLifeInsurance: !1,
                pendingOrPlanToBuyAdditional: !1,
                firstname: r.comfirmDetailsFirstName,
                lastname: r.comfirmDetailsLastName,
                dob: this.formatDate(r.comfirmDetailsDateOfBirth),
                email: r.comfirmDetailsEmailID,
                phone: r.comfirmDetailsPhoneNumber,
                address: {
                  addressLine1: r.insuredInfo.insuredStreetAddress,
                  city: r.insuredInfo.insuredCity,
                  state: r.insuredInfo.insuredState,
                  country: "US",
                  zip: r.insuredInfo.insuredZipcode
                },
                ssn: r.ssn,
                countryBorn: {
                  country: r.countryBornCode,
                  state: "US" == r.countryBornCode ? r.stateCodeAtBirth : null
                },
                isDependent: {
                  dependent: !0,
                  address: r.fullAddress,
                  relationship: "Child",
                  email_id: "abc1234@gmail.com",
                  ssn: r.ssn
                },
                addBeneficiaries: r.addBeneficiaryInfo,
                isActiveMilitary: p,
                insurancePurpose: [r.insurancePurpose],
                product: {
                  lob: "Life",
                  productType: "Term",
                  productCode: "FT6518",
                  productName: "Next Term Life"
                },
                agent: {
                  name: {
                    firstName: "Foo",
                    lastName: "Bar"
                  },
                  carrierAgentId: "W1WWW",
                  carrierMasterAgentId: "NXT-FNP-00034",
                  channel: "WFG",
                  carrierAgencyAddress: {
                    addressLine1: "20657 Golden Springs Dr",
                    city: "Diamond Bar",
                    state: "CA",
                    zip: "91789-3898",
                    country: "US",
                    addressLine2: "Ste 209"
                  },
                  carrierAgencyId: "T372A",
                  licenseId: "CA-0H29299",
                  carrierAgentWebsites: ["www.foo.com", "www.bar.com"]
                }
              }, "Yes" == r.ownerInsuredDifferent ? (u = r.policyOwnerInfo.policyOwnerSSN.split("-").join(""), c.policyOwner = {
                firstname: r.policyOwnerInfo.policyOwnerFirstName,
                lastname: r.policyOwnerInfo.policyOwnerLastName,
                dob: this.formatDate(r.policyOwnerInfo.policyOwnerDob),
                email: r.policyOwnerInfo.policyOwnerEmail,
                phone: r.comfirmDetailsPhoneNumber,
                address: {
                  addressLine1: r.policyOwnerInfo.policyOwnerStreetAddress,
                  city: r.policyOwnerInfo.policyOwnerCity,
                  state: r.policyOwnerInfo.policyOwnerState,
                  country: "US",
                  zip: r.policyOwnerInfo.policyOwnerZipcode
                },
                ssn: u,
                relationship: r.policyOwnerInfo.policyOwnerRelationship
              }) : c.policyOwner = {
                firstname: r.comfirmDetailsFirstName,
                lastname: r.comfirmDetailsLastName,
                dob: this.formatDate(r.comfirmDetailsDateOfBirth),
                email: r.comfirmDetailsEmailID,
                phone: r.comfirmDetailsPhoneNumber,
                address: {
                  addressLine1: r.insuredInfo.insuredStreetAddress,
                  city: r.insuredInfo.insuredCity,
                  state: r.insuredInfo.insuredState,
                  country: "US",
                  zip: r.insuredInfo.insuredZipcode
                },
                ssn: r.ssn,
                relationship: "Self"
              }, l = {}, "Yes" == r.thirdPartyNotified && (l.thirdPartyDesignation = {
                name: {
                  firstName: r.thirdPartyInfo.thirdPartyFirstName,
                  lastName: r.thirdPartyInfo.thirdPartyLastName
                },
                address: {
                  addressLine1: r.thirdPartyInfo.thirdPartyStreetAddress,
                  city: r.thirdPartyInfo.thirdPartyCity,
                  state: r.thirdPartyInfo.thirdPartyState,
                  country: "US",
                  zip: r.thirdPartyInfo.thirdPartyZipcode
                },
                phone: r.thirdPartyInfo.thirdPartyPhone.split("-").join("")
              }), d = "", _ = "", "Yes" == r.contingentBeneficiaries) for (l.contingentBeneficiaries = [], m = 0; m < r.contingentBeneficiaryInfo.length; m++) d = "Individual", _ = r.contingentBeneficiaryInfo[m].contingentBeneficiaryFirstName, r.contingentBeneficiaryInfo[m].contingentBeneficiaryRelationship.includes("Trust") && (d = "Trust"), r.contingentBeneficiaryInfo[m].contingentBeneficiaryRelationship.includes("Estate") && (d = "Estate", _ = "Estate of Insured"), l.contingentBeneficiaries[m] = {
                percentage: Number(r.contingentBeneficiaryInfo[m].contingentBeneficiaryPercentage),
                classification: d,
                relationship: r.contingentBeneficiaryInfo[m].contingentBeneficiaryRelationship,
                individualName: {
                  firstName: r.contingentBeneficiaryInfo[m].contingentBeneficiaryFirstName,
                  lastName: r.contingentBeneficiaryInfo[m].contingentBeneficiaryLastName
                },
                name: _
              };
              if ("Yes" == r.hasPendingApplications) for (c.pendingOrPlanToBuyAdditional = !0, l.pendingOrPlannedPolicies = [], y = 0; y < r.pendingApplicationInfo.length; y++) l.pendingOrPlannedPolicies[y] = {
                company: r.pendingApplicationInfo[y].pendingApplicationCompany,
                lob: r.pendingApplicationInfo[y].pendingApplicationProductType,
                type: r.pendingApplicationInfo[y].pendingApplicationType,
                purpose: r.pendingApplicationInfo[y].pendingApplicationPurpose,
                faceAmount: Number(r.pendingApplicationInfo[y].pendingApplicationFaceAmount)
              };else c.pendingOrPlanToBuyAdditional = !1;
              if ("Yes" == r.terminatingExistingPolicies ? l.terminatingExistingPolicies = !0 : l.terminatingExistingPolicies = !1, "Yes" == r.useFundsFromExistingPolicies ? l.useExistingPolicyFunds = !0 : l.useExistingPolicyFunds = !1, l.existingPolicies = [], g = "", w = 0, "Yes" == r.hasExistingLifeInsurance) for (c.existingLifeInsurance = !0, f = 0; f < r.existingPolicyInfo.length; f++) "" != r.existingPolicyInfo[f].existingPolicyCompany && (l.existingPolicies[f] = {
                company: r.existingPolicyInfo[f].existingPolicyCompany,
                lob: r.existingPolicyInfo[f].existingPolicyProductType,
                type: r.existingPolicyInfo[f].existingPolicyType,
                purpose: r.existingPolicyInfo[f].existingPolicynPurpose,
                benefitAmt: Number(r.existingPolicyInfo[f].existingPolicyBenefitAmount),
                isReplacement: !(!r.existingPolicyInfo[f].existingPolicyConfirm || "Yes" !== r.existingPolicyInfo[f].existingPolicyConfirm)
              }, g = r.existingPolicyInfo[f].existingPolicyNumber, (w = Number(r.existingPolicyInfo[f].existingPolicyIssueYear)) > 1990 && w < 2100 && (l.existingPolicies[f].issueYear = w), g.length > 0 && (l.existingPolicies[f].policyNumber = g));else c.existingLifeInsurance = !1;
              for (h = mapper.getAnswerJson2("paclife", c), h = Object.assign(h, l), "Yes" === r.hasDriverLicense && (h.insured.driversLicense = {
                number: r.driverLicenseInfo.driverLicenseNumber,
                state: r.driverLicenseInfo.driverLicenseIssuedState
              }), I = 0; I < h.primaryBeneficiaries.length; I++) h.primaryBeneficiaries[I].relationship.includes("Trust") && (h.primaryBeneficiaries[I].classification = "Trust", h.primaryBeneficiaries[I].name = h.primaryBeneficiaries[I].individualName.firstName), h.primaryBeneficiaries[I].relationship.includes("Estate") && (h.primaryBeneficiaries[I].classification = "Estate", h.primaryBeneficiaries[I].name = "Estate of Insured"), delete h.primaryBeneficiaries[I].dob;
              return console.log("clientData['isInsuredDependent']: ", r.isInsuredDependent), console.log("Before TWEAK ticketBody: ", h), "Yes" === r.isInsuredDependent ? h.insured.isDependent = !0 : (r.isInsuredDependent, h.insured.isDependent = !1), console.log("ticketBody: ", h), console.log("ticketBody: ", JSON.stringify(h)), e.next = 48, axios({
                method: "post",
                url: i + "/paclife/ticket",
                data: h
              });
            case 48:
              return P = e.sent, console.log("paclifeTicketOutput: ", P.data), A = {
                id: t,
                clientId: t,
                uid: t
              }, x = "paclife_".concat(n).split("-").join("_"), A[x] = P.data, A[x + "_ticket_body"] = JSON.stringify(h), e.next = 56, BackendService.saveUpdateClientData(t, A);
            case 56:
              return N = {
                client_id: t,
                email_id: "",
                phone: "",
                action_type: "api",
                full_name: "",
                carrier: "PACLIFE",
                lob: "LIFE",
                functionality_group: "PACLIFE_TICKET_SUBMIT",
                session_id: "",
                api_group_id: "",
                dynamodb_id: t,
                tags: ""
              }, BackendService.bo_log(N, "api"), e.abrupt("return", P.data);
            case 59:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (n) {
        return e.apply(this, arguments);
      })
    }, {
      key: "checkAuth0MetaData",
      value: function () {
        axios.request({
          method: "POST",
          url: "https://bubbleinsurtech.us.auth0.com/api/v2/users/auth0|604fb6e5dfec8a0069605fce",
          headers: {
            authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6Im9lWFpwSW5qeUlQbTZEbGVoVG5IWSJ9.eyJpc3MiOiJodHRwczovL2J1YmJsZWluc3VydGVjaC51cy5hdXRoMC5jb20vIiwic3ViIjoiRExmWE0wcWtuaEg5U1ZEQmtzYmdRNXkyUE5wRThsc25AY2xpZW50cyIsImF1ZCI6Imh0dHBzOi8vYnViYmxlaW5zdXJ0ZWNoLnVzLmF1dGgwLmNvbS9hcGkvdjIvIiwiaWF0IjoxNjIzNjg2NjEyLCJleHAiOjE2MjM3NzMwMTIsImF6cCI6IkRMZlhNMHFrbmhIOVNWREJrc2JnUTV5MlBOcEU4bHNuIiwiZ3R5IjoiY2xpZW50LWNyZWRlbnRpYWxzIn0.TXq5R5Y8ma5XghVmDLpeO2UCXjacy9h8K159BGi52sqvB2vSAa7EKZIaePXGSQpkKZo0yrL6lhgNODOLOulVt3Pm2sgvXKOmWeMT6Adnv1Be1Qmpson2CthYEyn4r6Te34hx3uspvSgq9sAj9-5V01vIgY9bxPsESNQAXZQlw3X326bJhaB6fqdW28pJ_tB_MTshAC-ITi2guks2sCMjdmwNlonMrBbEP_azyeHrgGqyHtHr0XilAsAl-CqGJuZvXNdh6wwcqwglnV92xZijyufo0E-EIBLii3ZFxbpv7L_jnb_3LXx-sgrcMOK4EjU5S04tMipYdrH4BEOVhMZXwA",
            "content-type": "application/json"
          },
          data: {
            email: "shridhar@getmybubble.com",
            user_metadata: {
              reference: "surfing"
            },
            app_metadata: {
              plan: "full"
            }
          }
        }).then(function (e) {
          console.log(e.data);
        }).catch(function (e) {
          console.error(e);
        });
      }
    }, {
      key: "formatDate",
      value: function (e) {
        var n = new Date(e),
          i = "" + (n.getMonth() + 1),
          t = "" + n.getDate(),
          r = n.getFullYear();
        return i.length < 2 && (i = "0" + i), t.length < 2 && (t = "0" + t), [r, i, t].join("-");
      }
    }]);
    var e, n;
  }();
module.exports = {
  Paclife: Paclife
};